export const ADMIN_PU = 'ADMIN_PU'
export const ADMIN = 'ADMIN'
export const USER = 'USER'
export default [
    {
        path: '/',
        redirect: '/app/tours',
    },
    {
        path: "/login",
        name: "login",
        component: require("./pages/login").default,
        meta: {
            layout: "single"
        },
    },
    {
        path: '/forgot-password',
        name: 'forgot_password',
        component: require('./pages/forgotPassword').default,
        meta: {
            layout: 'single',
        }
    }, {
        path: '/reset-password',
        name: 'reset_password',
        component: require('./pages/resetPassword').default,
        meta: {
            layout: 'single',
        }
    },
    {
        path: '/app',
        component: require('./pages/main').default,
        meta: {
            auth: [USER, ADMIN_PU, ADMIN]
        },
        children: [
            {
                path: "tours",
                name: "tours",
                component: require("./pages/tours/tours").default,
                meta: {
                    auth: [USER, ADMIN_PU, ADMIN]
                }
            },
            {
                path: "tours/:id",
                name: "tours_detail",
                component: require("./pages/tours/detail").default,
                meta: {
                    auth: [USER, ADMIN_PU, ADMIN]
                }
            },
            {
                path: "customers",
                name: "customers",
                component: require("./pages/referentiels/customers/customers").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "customers/:id",
                name: "customers_detail",
                component: require("./pages/referentiels/customers/detail").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "drivers",
                name: "drivers",
                component: require("./pages/referentiels/drivers/drivers").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "sites",
                name: "sites",
                component: require("./pages/referentiels/sites/sites").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "sites/new",
                name: "sites_new",
                component: require("./pages/referentiels/sites/new").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "sites/:id",
                name: "sites_edit",
                component: require("./pages/referentiels/sites/edit").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "tours_models",
                name: "tours_models",
                component: require("./pages/referentiels/tours_models/tours_models").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "tours_models/new",
                name: "tours_models_new",
                component: require("./pages/referentiels/tours_models/new").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "tours_models/:id",
                name: "tours_models_edit",
                component: require("./pages/referentiels/tours_models/edit").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "tours_types",
                name: "tours_types",
                component: require("./pages/referentiels/tours_types/tours_types").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "tours_types/new",
                name: "tours_types_new",
                component: require("./pages/referentiels/tours_types/new").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "tours_types/:id",
                name: "tours_types_edit",
                component: require("./pages/referentiels/tours_types/edit").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "users",
                name: "users",
                component: require("./pages/referentiels/users/users").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
            {
                path: "administration",
                name: "administration",
                component: require("./pages/administration/administration").default,
            },
            /*{
                path: "messaging",
                name: "messaging",
                component: require("./pages/messaging/messaging").default,
            },*/
            {
                path: "monitoring",
                name: "monitoring",
                component: require("./pages/monitoring/monitoring").default,
                meta: {
                    auth: [ADMIN_PU, ADMIN]
                }
            },
        ]
    },

    {
        path: "/403",
        name: "forbidden",
        component: require("./pages/errors/403").default,
        meta: {
            layout: "single",
        },
    }, {
        path: "/404",
        name: "not_found",
        component: require("./pages/errors/404").default,
        meta: {
            layout: "single",
        },
    },
];
